import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { clearAuthError } from '../actions/auth';
import isEmail from 'validator/lib/isEmail';
// import LoadingPage from './LoadingPage'
import ProgressSpinner from './ProgressSpinner'
// import getAppConfigParm  from '../config/AppConfig';


// This form is simply responsible for presenting the form, validating inputs, saving form data in 
// local state, and passing the form data to the onSubmit function prop that was passed in from parent.
// Goal is to keep track of local state for all of the inputs. Only when form has been validated successfully
// within the local onSubmit, do we want to dispatch an action. This action will be dispatched by the parent.
// If there are any form errors, the formError property (within the component state) will be set and
// the onSubmit passed from the parent component will not be called.
// If there are any authentication or api call errors (from the action that was dispatched from parent), 
// it will be logged as an auth.error on the redux store. The displayError() method will check if
// either form error or auth error exists. If so, it shows the error message on top of the form. The 
// local Form error property will be reset to null (thru isValidForm method) when form is resubmitted with no errors. The auth error
// The auth.error property, on redux store will, be reset when user logs in successfully (via startlogin action)
// or when the component unmounts (via componentWillUnmount).
class LoginForm extends React.Component {
    constructor(props) {
        super(props);
    
        // local component state
        this.state = {
            email:              props.formData ? props.formData.email : '',
            password:           props.formData ? props.formData.password : '',
            formError: ''
        };
    }

    // -----------------------------------------------------------
    // Life cycle methods
    // -----------------------------------------------------------

    // If there is an auth error on the redux store, clear it before unmounting compoment
    componentWillUnmount() {
        if (this.props.auth.error) {
            this.props.clearAuthError();
        }
     }


    // -----------------------------------------------------------
    // Event Handlers
    // -----------------------------------------------------------
    onEmailChange = (e) => {
        const email = e.target.value.trim();     // assign input value to email; allows to use object shorthand on next line
        this.setState(() => ({ email })); // update email on local state using ES6 shorthand
        // this.setState(
        //     { email: e.target.value },
        //     () => { console.log(`${this.state.firstname} ${this.state.lastname}`)
        //             console.log(`${this.state.email}`) }
        // );
    };

    onPasswordChange = (e) => {
        const password = e.target.value.trim();     // assign input value to description; allows to use object shorthand on next line
        this.setState(() => ({ password })); // update description on local state using ES6 shorthand
    };

    // Note: this local onSubmit method does form validation, but does not dispatch the 
    // action responsible for logging in user and saving auth token. 
    // The dispatch is done by the onSubmit method passed in as a function prop, from the 
    // Parent page. The function prop (this.props.onSubmit) is invoked with data needed 
    // for the Parent page to decide if and when an action is dispatched.
    onSubmit = (e) => {
        let self = this;
        e.preventDefault();


        // Every time user hits Login button, be sure to  enable button
        // this.setState({button_enable: true});

        // If no errors on the form, call the onSubmit method on parent component, which 
        // dispatches the startLogin action, which logins user, sets isAuthenticated, and
        // saves token.
        if (this.isValidForm()) {

            // Disable button right before firing startLogin action.
            // this.setState({button_enable: false});

            // fire off startLogin action from the Parent onsubmit function
            this.props.onSubmit({
                email: this.state.email,
                password: this.state.password
            });
        }; 
    };
   

    render() {
        return (
            // !this.state.formLoaded ? <ProgressSpinner /> :
            this.props.auth.loginInProgress ? <ProgressSpinner /> :
            (
            <form className="form-login" onSubmit={this.onSubmit}>
                {this.displayError()}            
                <input 
                    type="text"
                    placeholder="Email address"
                    className="form__field"
                    onChange={this.onEmailChange}    // change the state.email value vi on change method
                    value={this.state.email}         // render component with value from state object
                />
                <input 
                    type="password"
                    placeholder="Password (minimum 8 chars)"
                    className="form__field"
                    value={this.state.password}
                    onChange={this.onPasswordChange}
                />
                <div>
                  <button className="login-button"
                  >
                    Log In
                  </button> 
                </div>
                <Link to="/forgotpw" className="small-text-link">Forgot Password?</Link> 
            </form>
            )
        )
    }

    // It will check if a local form error exist first, and render error message.
    // If not, it checks for an auth error exist (that may have been triggered by login action). 
    // If found, it renders the authentication error 
    displayError = () => {
        if (this.state.formError) {
            return <p className="error">{this.state.formError}</p>
        }
        if (this.props.auth.error) {
            return <p className="error">{this.props.auth.error}</p>
        }
    }
  
    isValidForm = () => {
        let valid = false;
        
        if (!this.state.email || !isEmail(this.state.email)) {
            this.setState(() => ({ formError: 'Please provide valid email address'}))
        } else
        if (!this.state.password) {
            this.setState(() => ({ formError: 'Please provide password'}))
        } else
        if (this.state.password.length < 8) {
            this.setState(() => ({ formError: 'Password minimum of 8 characters'}))
        } else 
        /*if (this.props.auth.error) { 
            this.setState(() => ({ formError: this.props.auth.error}))
        } else */ {   // Clear the error when all validations passed
            this.setState(() => ({ formError: ''}));
            valid = true;
        }
        return valid;
    }
   
} // END OF REACT component

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

const mapDispatchToProps = (dispatch) => ({
    clearAuthError: () => dispatch(clearAuthError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);


// {this.state.formError && <p className="form__error">{this.state.formError}</p>}
//             {this.props.auth.error && <p className="form__error">{this.props.auth.error}</p>}
// disabled={this.props.auth.loginInProgess}


// WEBPACK FOOTER //
// ./src/components/LoginForm.js